export function isUnauthorizedError(error: Error): boolean {
  return /^401: .*Unauthorized/.test(error.message);
}

export function clearNavigationAndFilterState(): void {
  const localKeysToRemove = [
    'communications-editor-active-panel',
    'communications-editor-last-slug',
    'communications-editor-sidebar-width',
    'communications-editor-sidebar-position',
    'currentUser',
  ];
  localKeysToRemove.forEach(key => localStorage.removeItem(key));

  Object.keys(localStorage)
    .filter(key => key.startsWith('diagnostics-comparison-presets-'))
    .forEach(key => localStorage.removeItem(key));

  const sessionKeysToRemove = [
    'lcc-cache-cleared-v2',
    'ai_analytics_filter',
    'comm:lastSlug',
    'comm:prevSlug',
    'documents-explorer-state',
    'dashboard-state',
    'cached-developer-franchises-v1',
  ];
  sessionKeysToRemove.forEach(key => sessionStorage.removeItem(key));
}